// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/index.css (Complete and Final) */

/* --- Global Font Import --- */

/* --- "Natural Clarity" Color Palette --- */
:root {
  --background-primary: #FFFFFF;
  --background-secondary: #F8F9FA;
  --text-primary: #212529;
  --text-secondary: #6C757D;
  --accent-primary: #2F855A; /* Sage Green */
  --accent-primary-hover: #276749; /* Darker Sage Green */
  --accent-secondary: #4A5568; /* Slate */
  --border-color: #DEE2E6;
  --error-color: #D32F2F;
}

/* --- CSS Reset and Base Styles --- */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
  
html {
    scroll-behavior: smooth;
}
  
body {
    margin: 0;
    font-family: 'Inter', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--background-primary);
    color: var(--text-primary);
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,+BAA+B;;AAG/B,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB,EAAE,eAAe;EAC1C,+BAA+B,EAAE,sBAAsB;EACvD,2BAA2B,EAAE,UAAU;EACvC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,2CAA2C;IAC3C,0BAA0B;IAC1B,kBAAkB;AACtB","sourcesContent":["/* frontend/src/index.css (Complete and Final) */\n\n/* --- Global Font Import --- */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n/* --- \"Natural Clarity\" Color Palette --- */\n:root {\n  --background-primary: #FFFFFF;\n  --background-secondary: #F8F9FA;\n  --text-primary: #212529;\n  --text-secondary: #6C757D;\n  --accent-primary: #2F855A; /* Sage Green */\n  --accent-primary-hover: #276749; /* Darker Sage Green */\n  --accent-secondary: #4A5568; /* Slate */\n  --border-color: #DEE2E6;\n  --error-color: #D32F2F;\n}\n\n/* --- CSS Reset and Base Styles --- */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n  \nhtml {\n    scroll-behavior: smooth;\n}\n  \nbody {\n    margin: 0;\n    font-family: 'Inter', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: var(--background-primary);\n    color: var(--text-primary);\n    overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
